export const dockedStyles = {
  zIndex: 1099,
};

export const guttersStyles = theme => ({
  padding: theme.spacing(2, 1, 2, 2),
});

export const listStyles = theme => ({
  height: '100%',
  [theme.breakpoints.up('lg')]: {
    width: '268px',
  },
});

export const listItemStyles = theme => ({
  '& >h6': {
    fontWeight: 300,
    marginTop: 2,
  },
  '& >svg': {
    color: theme.palette.secondary.main,
  },
  '&$selected': {
    backgroundColor: theme.palette.secondary.light,
  },
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const paperStyles = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  backgroundColor: theme.palette.surface.white,
  borderRight: `1px solid ${theme.palette.graphic.light}`,
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  top: theme.spacing(7),
  [theme.breakpoints.up('sm')]: {
    top: theme.spacing(8),
  },
  [theme.breakpoints.up('md')]: {
    top: theme.spacing(6),
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: '50%',
  },
  [theme.breakpoints.between('md', '1024')]: {
    top: theme.spacing(8),
    width: '33%',
  },
});

export const selectedStyles = {};
